'use client';
import { useState } from 'react';
import InputField from '../components/InputField';
import TextAreaField from '../components/TextAreaField';
import Button from '../components/Button'; 
import FAQSection from '../section/FAQSection';
import { motion } from 'framer-motion';

export default function ContactUs() {
  // Animation variants for the header, form, and button
  const fadeIn = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  const slideUp = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  const staggeredItems = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.2,
      },
    },
  };

  return (
    <section className="min-h-screen">
      <div className="bg-gray-50 px-4 sm:px-6 lg:px-16 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <motion.div
            variants={fadeIn}
            initial="hidden"
            animate="visible"
            className=""
          >
            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900">We're Here!</h1>
            <p className="mt-2 text-gray-600">Let us know what kind of help you need or visit our FAQ for quick answers.</p>
          </motion.div>

          <motion.div
            variants={slideUp}
            initial="hidden"
            animate="visible"
            className="bg-white p-6 shadow rounded-lg"
          >
            <h2 className="text-lg font-semibold text-gray-800 mb-4">We're always available to help</h2>
            <form className="flex flex-col gap-8">
              <motion.div variants={slideUp} initial="hidden" animate="visible">
                <InputField label="Full name" placeholder="Enter your full name" />
              </motion.div>
              <motion.div variants={slideUp} initial="hidden" animate="visible">
                <InputField label="Email address" type="email" placeholder="Enter your email address" />
              </motion.div>

              <motion.div variants={slideUp} initial="hidden" animate="visible">
                <TextAreaField
                  label=""
                  placeholder="What's on your mind?"
                />
              </motion.div>

              <motion.div
                variants={fadeIn}
                initial="hidden"
                animate="visible"
                className="flex items-center"
              >
                <input
                  type="checkbox"
                  name="agree"
                  className="mr-2 w-6 h-6 md:w-4 md:h-4"
                  required
                />
                <label className="text-gray-600 text-sm md:text-base">
                  I agree to the <a href="#" className="text-orange-500">Terms of Service & Privacy Policy</a>.
                </label>
              </motion.div>

              <motion.div variants={fadeIn} initial="hidden" animate="visible">
                <Button type="submit" className="w-full">
                  Send Message
                </Button>
              </motion.div>
            </form>
          </motion.div>
        </div>
      </div>
      <FAQSection />
    </section>
  );
}
